import {
  PropertyDetails,
  PropertyDetailsProps,
} from "../../common/PropertyDetails";

export type PropertyDetailsSidebarProps = PropertyDetailsProps & {
  isLoading?: boolean;
};

export const PropertyDetailsSidebar = ({
  listing,
  onAddNoteClick,
  onAddTagClick,
  onFavoriteClick,
  isNotesEnabled = true,
  isTagsEnabled = true,
  isLoading = false,
  isHideDNCPhoneNumbers,
}: PropertyDetailsSidebarProps) => (
  <PropertyDetails
    listing={listing}
    isLoading={isLoading}
    isContactEditingDisabled
    isNotesEnabled={isNotesEnabled}
    isTagsEnabled={isTagsEnabled}
    onAddNoteClick={onAddNoteClick}
    onAddTagClick={onAddTagClick}
    onFavoriteClick={onFavoriteClick}
    isHideDNCPhoneNumbers={isHideDNCPhoneNumbers}
  />
);
